// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"style_iframeWrapper__Sy+eQ","standard":"style_standard__HWuyC","expanded":"style_expanded__QvCsT","useFullWidth":"style_useFullWidth__YVqti"};